import React from 'react'
import ReactDOM from 'react-dom/client'
import '@mercedes-benz/typeface-mb-corpo-s'
import '@mercedes-benz/typeface-mb-corpo-a'
import './index.css'
import App, { isLocal } from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './source/Store'
import { AccountInfo, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser'
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge'
import { msalConfig } from './config/authConfig'
import { MsalProvider } from '@azure/msal-react'
import { MsalReactTester } from 'msal-react-tester'
import './config/i18n'

export let msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig)

async function initApp() {
    await msalInstance.initialize()

    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            msalInstance.setActiveAccount(event.payload as AccountInfo)
        }
    })

    if (isLocal) {
        const msalTester = new MsalReactTester()
        await msalTester.isLogged()
        msalInstance = msalTester.client as unknown as PublicClientApplication
    }


    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
    root.render(
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <App />
            </Provider>
        </MsalProvider>
    )
    reportWebVitals()
}

// Detect if this page is loaded inside an MSAL silent-auth iframe.
// MSAL v5 uses BroadcastChannel (waitForBridgeResponse) for iframe auth:
// the iframe MUST run MSAL and call handleRedirectPromise() to post the
// auth code back to the parent via BroadcastChannel.
// We initialize MSAL minimally here (no React) so the response is sent
// back without loading the full app, which prevents block_iframe_reload
// and BSSO extension triggers.
const isMsalAuthIframe =
    window.parent !== window &&
    (window.location.hash.includes('code=') ||
        window.location.search.includes('code=') ||
        window.location.hash.includes('error=') ||
        window.location.search.includes('error=')) &&
    (window.location.hash.includes('state=') || window.location.search.includes('state='))

if (isMsalAuthIframe) {
    // Use the official MSAL v5 redirect bridge: processes the auth response
    // from the URL and broadcasts it to the parent via BroadcastChannel (COOP-safe).
    // No full MSAL instance or React rendering needed.
    broadcastResponseToMainFrame().catch(() => {
        /* Errors are handled by the parent's waitForBridgeResponse timeout */
    })
} else {
    initApp().catch((error) => {
        console.error('Failed to initialize app:', error)
    })
}
